var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 40,
    viewBox: "0 0 160 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1500)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 40,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 34,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 34)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 40,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 40)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 40,
    width: 6,
    height: 6,
    transform: "rotate(-90 142 40)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 34,
    width: 6,
    height: 6,
    transform: "rotate(-90 148 34)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 154 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 148 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 40,
    width: 6,
    height: 6,
    transform: "rotate(-90 154 40)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.44 25.3C58.34 25.3 59.36 23.42 59.36 20.8V19.2C59.36 16.58 58.34 14.7 55.44 14.7H52.76V25.3H55.44ZM51 27V13H55.44C59.16 13 61.16 15.38 61.16 19.2V20.8C61.16 24.62 59.16 27 55.44 27H51ZM62.8594 27V16.78H64.5394V27H62.8594ZM62.7594 14.66V12.7H64.6394V14.66H62.7594ZM70.2175 27.18C67.7975 27.18 66.0975 26 66.0375 23.62H67.7175C67.7175 24.98 68.7575 25.58 70.2175 25.58C71.6975 25.58 72.5575 24.96 72.5575 24.1C72.5575 23.48 72.1175 23.04 71.1975 22.8L68.7975 22.2C67.3375 21.84 66.4575 20.94 66.4575 19.48C66.4575 17.86 67.7775 16.6 70.1175 16.6C72.4375 16.6 74.0175 17.96 74.0175 19.9H72.3775C72.3175 18.7 71.3975 18.14 70.1175 18.14C68.7575 18.14 68.0775 18.74 68.0775 19.48C68.0775 20.24 68.6575 20.5 69.3775 20.68L71.5575 21.22C73.2975 21.66 74.2575 22.54 74.2575 24.1C74.2575 25.86 72.7575 27.18 70.2175 27.18ZM79.2723 27.18C76.7123 27.18 75.0523 25.62 75.0523 22.9V20.88C75.0523 18.16 76.7123 16.6 79.2723 16.6C81.6723 16.6 83.4123 17.96 83.4523 20.38H81.7523C81.7123 18.86 80.6123 18.2 79.2723 18.2C77.7923 18.2 76.7523 19 76.7523 20.88V22.9C76.7523 24.98 77.7923 25.58 79.2723 25.58C80.6123 25.58 81.7123 25.08 81.7523 23.44H83.4523C83.4123 25.82 81.6523 27.18 79.2723 27.18ZM84.243 20.88C84.243 18.16 85.903 16.6 88.463 16.6C91.023 16.6 92.663 18.16 92.663 20.88V22.9C92.663 25.62 91.023 27.18 88.463 27.18C85.903 27.18 84.243 25.62 84.243 22.9V20.88ZM85.943 22.9C85.943 24.98 86.983 25.58 88.463 25.58C89.943 25.58 90.963 24.98 90.963 22.9V20.88C90.963 19 89.943 18.2 88.463 18.2C86.983 18.2 85.943 19 85.943 20.88V22.9ZM94.2727 27V16.78H95.9727V17.96C96.4727 17.22 97.2127 16.78 98.5727 16.78H99.5927V18.48H98.5727C97.0327 18.48 95.9727 19.34 95.9727 21.46V27H94.2727ZM103.895 27.18C101.335 27.18 99.6945 25.62 99.6945 22.9V20.88C99.6945 18.16 101.335 16.6 103.895 16.6C104.915 16.6 105.775 16.9 106.415 17.46V12.2H108.115V27H106.415V26.32C105.775 26.88 104.915 27.18 103.895 27.18ZM101.395 22.9C101.395 24.98 102.415 25.58 103.895 25.58C105.275 25.58 106.415 24.98 106.415 22.9V20.88C106.415 19 105.275 18.2 103.895 18.2C102.415 18.2 101.395 19 101.395 20.88V22.9Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 39,
    stroke: "#151515"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/Discord.913d100b9b160d40693c5d71c8730cd0.svg";
export { ForwardRef as ReactComponent };